import React from 'react';
import './styles.scss';

function SectionButton() {
    return (
        <section className="section-button">
            <div className="container">
                <h3>Why you still reading?</h3>
                <button>Order yours now!</button>
            </div>
        </section>
    )
}

export default SectionButton;
